class Checkout {
    constructor() {
        if (document.querySelector("#checkout-form-submit")) {
            this.submitButton = document.querySelector("#checkout-form-submit")

            this.events()
        }
    }

    events() {
        const timer = setInterval(() => {
            if (document.querySelector(".checkout-form-ready")) {
                this.activateButton()
                clearInterval(timer)
            }
         }, 500);
    }

    // methods
    activateButton() {
        this.submitButton.disabled = false
    }
}

export default Checkout
